import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import { Box, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';

import FormCloseButton from '../../../components/Form/FormCloseButton';
import {
  selectIsUserDetailLoading,
  selectUpdateUserIsProcessing,
  selectUserDetail,
} from '../../../store/selectors/userListSelector';
import theme from '../../../theme';
import { ROUTE_CONSTANTS } from '../../app/RouteBuilding/routeConstants';
import { getUserDetail, setUserDetail } from '../usersListReducer';

import useFetchUserProfilePicture from './useFetchUserProfilePicture';
import UserDetailLeft from './UserDetailLeft';
import UserDetailRight from './UserDetailRight';

const UserDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedUser = useSelector(selectUserDetail)?.[0];

  const isUserDetailLoading = useSelector(selectIsUserDetailLoading);
  const isUpdateUserProcessing = useSelector(selectUpdateUserIsProcessing);
  const { id } = useParams();
  useFetchUserProfilePicture(selectedUser);

  useEffect(() => {
    if (!id) {
      dispatch(setUserDetail({}));
    } else {
      dispatch(
        getUserDetail({
          filters: [{ field: '_id', value: id, operation: 'equalsID' }],
        })
      );
    }
    return () => {
      dispatch(setUserDetail({}));
    };
  }, [dispatch, id, isUpdateUserProcessing]);

  return isUserDetailLoading ? (
    <CircularProgress />
  ) : (
    <Box
      sx={{
        height: '100vh',
        padding: '25px',
        display: 'flex',
        flexDirection: 'column',
        gap: '36px',
      }}
    >
      <FormCloseButton
        onClose={() => navigate(`/${ROUTE_CONSTANTS.USERS_V2}${location.search}`)}
        message="buttonText.goBack"
      />
      <Grid container sx={{ height: '100%' }}>
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            backgroundColor: `${theme?.components?.detailLeft?.palette?.backgroundColor}`,
            padding: '16px',
            display: 'flex',
            justifyContent: 'center',
            minWidth: '300px',
          }}
        >
          <UserDetailLeft />
        </Grid>

        <Grid item xs={12} md={9} sx={{ padding: 2 }}>
          {selectedUser?.role === UserRole.CANDIDATE && <UserDetailRight />}
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserDetail;
